// extracted by mini-css-extract-plugin
module.exports = {"container":"OpportunityAiSummary_container__ysV56","list-heading":"OpportunityAiSummary_list-heading__RY2EQ"};